export default __webpack_public_path__ + "static/media/important-dates.db91c490.svg";